import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { type ValidationFunctionOptions, Validator } from '@adornis/validation/validator.js';
import { isLehrkraft } from '@martinus/taetigkeit/enums/Taetigkeiten.js';
import type { AGEingruppierung } from './AGEingruppierung.js';

@Entity()
export class AGArbeitszeit extends AdornisEntity {
  static override _class = 'AGArbeitszeit';

  @Field(() => Float)
  maxDeputat: Maybe<number>;

  @Field(() => Float)
  zaehler: Maybe<number>;

  @Field(() => Float)
  stunden: Maybe<number>;

  @Field(() => Boolean, { default: v => v ?? false })
  ferienEinarbeiten!: boolean;
}

if (A.isClient) {
  const getIsLehrkraftForPath = (options: ValidationFunctionOptions<any, unknown>) => {
    const eingruppierung = options.source?.[options.path?.[0] ?? 'undefined'] as Maybe<AGEingruppierung>;
    if (!eingruppierung) {
      throw new ValidationError('AGEingruppierung not found');
    }

    return isLehrkraft(eingruppierung.agVertragsInfos?.taetigkeit);
  };

  AGArbeitszeit.prototype.validator = new Validator({
    stunden: options => {
      const lehrkraft = getIsLehrkraftForPath(options);

      if (!lehrkraft) return nonOptional()(options);
    },
    maxDeputat: options => {
      const lehrkraft = getIsLehrkraftForPath(options);

      if (lehrkraft) return nonOptional()(options);
    },
  });
}
